import { useQuery } from 'react-query';

import feathersClient from '../../../../../apiClient';
import Protect from '../../../../../apiClient/Protect';
import { SecondaryButton } from '../../../../../components/buttons';
import { useDocumentDownload } from '../../../../../hooks/useDocumentDownload';
import { PersonDocumentFileData } from '../../../../../types/TymbeApi';
import { Roles } from '../../../../../utils/enums';
import Modal from 'react-modal';
import UploadDocumentFile from '../../../../../components/upload/UploadDocumentFile/UploadDocumentFile';
import classNames from 'classnames';
import styles from '../../../../../components/TyAdvancedSearch/Components/Layout.module.css';

export interface DocumentListProps {
  documentId: number;
  onDocumentClick?: (document: PersonDocumentFileData) => void;
}

const DocumentList = ({ documentId, onDocumentClick }: DocumentListProps) => {
  const { downloadDocument } = useDocumentDownload();

  const { data: personDocuments } = useQuery(['person-document-list', documentId], async () =>
    feathersClient.service('person-document').get(documentId, {
      query: {
        $eager: '[personDocumentFile]',
      },
    }));

  // creates unique file name
  const splitBySlash = (str: string) => {
    const lastIndex = str.lastIndexOf('/');
    return str.slice(lastIndex + 1);
  };

  const handleDownload = (documentFile: PersonDocumentFileData) => {
    const fileName = splitBySlash(documentFile.file);
    downloadDocument(documentFile.file, fileName);
  };

  return (
    <>
      <div>
        {personDocuments?.personDocumentFile.length === 0 ? (
          <div className="p-4">Žádné soubory ke stažení</div>
        ) : (
          personDocuments?.personDocumentFile.map(
            (documentFile: PersonDocumentFileData) => (
              <div key={documentFile.file} className="flex items-center gap-2 p-2">
                <button
                  className="hover:underline flex-1 text-left"
                  onClick={() => onDocumentClick?.(documentFile)}
                  type="button"
                >
                  {splitBySlash(documentFile.file)}
                </button>
                <Protect
                  auth={[
                    Roles.SUPER_ADMIN,
                    Roles.TYMBE_ADMIN,
                    Roles.TYMBE_COORDINATOR,
                    Roles.COMPANY,
                  ]}
                  redirect={false}
                >
                  <SecondaryButton
                    onClick={() => handleDownload(documentFile)}
                    className="text-xs px-2 py-1"
                  >
                    Stáhnout
                  </SecondaryButton>
                </Protect>
              </div>
            ),
          )
        )}
      </div>
    </>
  );
};

export default DocumentList;
